import type { ReactNode } from "react";
import { AnimatePresence, motion } from "motion/react";
import { cx } from "class-variance-authority";
import * as styles from "./Drawer.module.scss";

type DrawerProps = {
  children?: ReactNode;
  isOpen: boolean;
  className?: string;
  skipInitial?: boolean;
};

const transition = {
  height: { duration: 0.2 },
  opacity: { duration: 0.15 },
};

const drawerVariants = {
  open: {
    opacity: 1,
    height: "auto",
    transition,
  },
  closed: {
    opacity: 0,
    height: 0,
    transition,
  },
};

const Drawer = ({ children, isOpen, className, skipInitial }: DrawerProps) => {
  return (
    <AnimatePresence initial={!skipInitial}>
      {isOpen && (
        <motion.div
          className={cx(styles.drawerContainer, className)}
          variants={drawerVariants}
          animate={isOpen ? "open" : "closed"}
          initial={"closed"}
          exit={"closed"}
        >
          {children}
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export { Drawer };
